import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RuleForm from '../inputs/RuleForm';
import InlineRegionSelect from '../inputs/InlineRegionSelect';
import InlineInputNumber from '../inputs/InlineInputNumber';


class UtilizationRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      percent: initialValues.percent || 90,
      regions: initialValues.regions && initialValues.regions.length > 0 ? initialValues.regions : [0]
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    const value = _.omit(this.state, 'regions');
    this.props.onSubmit({
      kind: 'utilization',
      regions: _.filter(this.state.regions),
      value
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { percent, regions } = this.state;
    const { form, type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
        isSubmitting={form.is_submitting}
      >
        <InlineRegionSelect
          value={regions}
          onChange={val => this.setState({ regions: val })}
        />
        <InlineInputNumber
          label='Percent Utilization'
          description='Percent of purchases made on Vetcove'
          displayFormat='percent'
          value={percent}
          onChange={value => this.setState({ percent: value })}
        />
      </RuleForm>
    );
  }
}

UtilizationRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

UtilizationRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default UtilizationRule;
